import { useTranslation } from "react-i18next";
import { useInitiatives, CATEGORY_ORDER } from "@/lib/useInitiatives";
import InitiativeCard from "@/components/InitiativeCard";

export default function Initiatives() {
  const { t } = useTranslation();
  const { byCategory } = useInitiatives();

  return (
    <div className="pb-24">
      <section className="border-b border-ink/10 py-20 circuit-bg-light" aria-labelledby="initiatives-title">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="tag mb-3">{t("initiatives_page.eyebrow")}</div>
          <h1 id="initiatives-title" className="font-display font-black text-brand text-4xl sm:text-5xl lg:text-6xl leading-[1]">
            {t("initiatives_page.title_a")} <span className="text-teal">{t("initiatives_page.title_b")}</span>.
          </h1>
          <p className="mt-6 text-ink/75 max-w-3xl leading-relaxed">{t("initiatives_page.intro")}</p>
        </div>
      </section>

      {CATEGORY_ORDER.map((cat) => (
        <section key={cat} className="py-14 border-b border-ink/10" aria-labelledby={`cat-${cat}`} data-testid={`initiatives-${cat}`}>
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-8">
            <div className="lg:col-span-3">
              <h2 id={`cat-${cat}`} className="font-display font-bold text-brand text-2xl sticky top-24">
                {t(`initiative.categories.${cat}`)}
                <span className="block mt-2 font-mono text-[10px] uppercase tracking-widest text-ink/60">{byCategory[cat].length} {byCategory[cat].length === 1 ? "item" : "items"}</span>
              </h2>
            </div>
            <div className="lg:col-span-9 grid md:grid-cols-2 xl:grid-cols-3 gap-4">
              {byCategory[cat].map((it, i) => <InitiativeCard key={it.slug} item={it} index={i} compact />)}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
